export class SettingsImportCashflowsDto {
  defaultInboundCashflowId: number;
  defaultOutboundCashflowId: number;
}